"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("../common/styles");

var _helper = require("../common/helper");

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _consts = require("../consts");

function PollStatusBar(props) {
  var poll = props.poll;
  var totalVoters = poll.totalVoters;
  var totalResponses = (0, _helper.getTotalResponses)(poll);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.pollStatusBar, _styles2.flexAlignCenterStretch, 'poll-status-bar')
  }, _react.default.createElement(_DarkText.default, {
    color: poll.status === _consts.PollStatus.LIVE ? 'emerald' : 'silver',
    fontSize: 10,
    letterSpacing: 2,
    uppercase: true
  }, poll.status), _react.default.createElement(_DarkText.default, {
    className: "seperator",
    fontSize: 12
  }, "\u2022"), _react.default.createElement(_DarkText.default, {
    fontSize: 10,
    letterSpacing: 2,
    uppercase: true
  }, "".concat(totalVoters ? "".concat(totalResponses, " / ").concat(totalVoters) : "".concat(totalVoters), " Learners Voted")));
}

var _default = PollStatusBar;
exports.default = _default;